export const MENU_HEIGHT = 64
/** The bottom bar of the noBGP app on a phone (PhoneTabBar.tsx): iOS's standard tab bar height,
 * above the home indicator. */
export const PHONE_TAB_BAR_HEIGHT = 49
export const REGEX_VALID_DOMAIN = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/
export const REGEX_VALID_CHARACTERS = /^[a-zA-Z0-9-]*$/
export const REGEX_VALID_URL_CHARACTERS = /^[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]+$/
export const REGEX_VALID_URL = /^(https?:\/\/)?([\w.-]+)(:\d+)?(\/[^\s]*)?$/
export const TRANSITION_DURATION = 400
export const POSTHOG_PROXY_FUNCTION = 'ph'
export const METRICS_UPDATE_INTERVAL = 1000 * 60 * 1 // 1 minute
export const BASE_ANIMATION_DURATION = 1000
export const MIN_ANIMATION_WINDOW = 5000 // Half second minimum
export const CONTINUOUS_ANIMATION_THRESHOLD = 1024 * 1024 // 1MB
export const CONTINUOUS_ANIMATION_DURATION = 60000 // 1 minute
export const OFFLINE_NODE_VISIBILITY_HOURS = 6
export const TOKEN_REFRESH_THRESHOLD = 1 * 60 * 1000 // Refresh 1 minute before token expiry
export const TOKEN_STATUS_RETRY_INTERVAL = 30 * 1000 // Retry fetching token status after 30 seconds on transient failure
// Published services have their own registrable domain, outside the control plane's
// `.nobgp.com` cookie scope (nobgp/nobgp-router#339). Must match the router's
// `config.ServiceDomain`.
export const SERVICE_DOMAIN = 'nobgp.link'
export const MCP_ENDPOINT = 'https://preview.nobgp.com/mcp'
export const CHATGPT_URL = 'https://chatgpt.com/g/g-68ffa00ec550819180332f8cfb1da68e-nobgp-preview'
export const CLAUDE_CHAT_URL = 'https://claude.ai'
export const CLAUDE_URL = 'https://docs.nobgp.com/claude-setup'
// The one documentation page behind every pricing claim the billing and usage panels make
// (app#211). Held here because TWO panels link it and a wrong path is a 404 in front of a
// customer: `/pricing`, `/plans` and `/billing` were all measured 404 on 2026-09-03, and
// `/plans-and-billing` 200.
export const DOCS_BILLING_URL = 'https://docs.nobgp.com/plans-and-billing'
// The provisioning page: what a compute node is, what survives a stop, and the compute classes.
// ⚠ There is no page yet that lists what is installed on the compute image (router review § 7).
// The compute dialog and the compute node page link here until that page exists.
export const DOCS_PROVISIONING_URL = 'https://docs.nobgp.com/provisioning-nodes'
export const FEEDBACK_SURVEY = {
  id: '019ab8ab-05ce-0000-6c27-f3b402f88ecf',
  name: 'Feedback',
  type: 'api',
  questions: {
    message: '35f49422-505c-418d-a6a8-3f53e3d81a77',
    reply: '7969ad7d-9f46-4609-8354-a4f921dd7e20',
  },
}

export const Z_INDEX = {
  GRAPH: 1,
  DRAWER: 1300,
  BANNER: 1400, // above the graph/drawer, below terminals (1500) and modals (2000)
  TERMINAL_BASE: 1500,
  TERMINAL_MAX: 1599,
  MODAL: 2000,
  TOOLTIP: 2010,
}

/** The drawer's tabs. The phone layout shows the same bar over the graph and the map (PhoneShell). */
export const DRAWER_TABS = [
  { label: 'Nodes', path: '/nodes' },
  { label: 'Networks', path: '/networks' },
  { label: 'Account', path: '/account' },
]
